import { Controller } from '@hotwired/stimulus';
import Vue from 'vue';

export default class extends Controller {
  static targets = ['template'];
  static values = {
    shopCard: Object,
    shopStamps: Array,
    defaultCouponImage: String,
    defaultStampImage: String,
    isEdit: Boolean,
  };

  connect() {
    const el = this.templateTarget;
    const isEdit = this.isEditValue;

    new Vue({
      el,
      data: {
        shop_card: this.shopCardValue,
        shop_stamps: this.shopStampsValue,
        preview_stamp_index: 0,
        default_coupon_image: this.defaultCouponImageValue,
        default_stamp_image: this.defaultStampImageValue,
        isEdit: isEdit ? 1 : 0,
        item: { user_coupon_id: 0, user_coupon_notice: null }, // render "/app/user/shared/coupon" でのJSエラー対策にダミー値セット
      },
      created: function () {
        // クーポンの並び順をソート
        for (let i = this.shop_stamps.length - 1; i >= 0; i--) {
          this.sortShopCoupon(i);
        }
      },
      methods: {
        hasStampBg: function (stampIndex) {
          return (
            this.shop_stamps[stampIndex].bg &&
            this.shop_stamps[stampIndex].bg.indexOf('default_shop_stamp_bg') ===
              -1
          );
        },
        getPreviewCouponImage: function (stampIndex, couponIndex) {
          const stamp = this.shop_stamps[stampIndex];
          if (!stamp) return '';
          if (!stamp.shop_coupons[couponIndex]) return '';
          return stamp.shop_coupons[couponIndex].picture_url_large || '';
        },
        changeShopStampFormat: function (index) {
          if (index > 0 && this.shop_stamps[index].format === 'point') {
            alertify.error('ポイントカードではランクアップを設定できません');
            this.shop_stamps[index].format = 'stamp';
          } else if (index === 0 && this.shop_stamps.length > 1) {
            alertify.error(
              'ランクアップ設定をしている場合、ポイントカードを選択できません',
            );
            this.shop_stamps[index].format = 'stamp';
          }
        },
        changeShopCouponStamp: function (parent_index, index) {
          const shop_stamp = this.shop_stamps[parent_index];
          const shop_coupon = shop_stamp.shop_coupons[index];

          if (
            shop_stamp.format === 'stamp' &&
            shop_coupon.stamps > shop_stamp.frames
          ) {
            shop_coupon.stamps = shop_stamp.frames;
            alertify.error(
              `設定できるスタンプ数はカード枠数（${shop_stamp.frames}）が上限になります`,
            );
          }
        },
        // カード枠数設定UI
        chageShopStampNumber: function (number, index) {
          // スタンプカード枠数の増減
          const shop_stamp = this.shop_stamps[index];
          const target_number =
            Number.parseInt(shop_stamp.frames, 10) +
            Number.parseInt(number, 10);
          if (target_number <= 0 || target_number > 100) {
            alertify.error('スタンプカードは、1〜100の範囲で設定してください');
            return false;
          }

          // スタンプカード列数
          switch (target_number) {
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
              shop_stamp.columns_per_record = target_number;
              break;
            case 8:
              shop_stamp.columns_per_record = 4;
              break;
            case 9:
              shop_stamp.columns_per_record = 3;
              break;
            case 10:
              shop_stamp.columns_per_record = 5;
              break;
            default: {
              // 11~100
              let ans_number = 0;
              let diff_number = target_number;
              let min_col_number = diff_number / 10;
              if (min_col_number > 9) {
                min_col_number = 9;
              }
              while (ans_number < 1) {
                for (let i = 10; i > min_col_number; i--) {
                  if (diff_number % i === 0) {
                    ans_number = i;
                    break;
                  }
                }
                diff_number++;
              }
              shop_stamp.columns_per_record = ans_number;
            }
          }

          // スタンプカード枠数
          shop_stamp.frames = target_number;

          // 枠数より大きい設定のクーポンを補正
          for (let j = 0; j < shop_stamp.shop_coupons.length; j++) {
            const shop_coupon = shop_stamp.shop_coupons[j];
            if (shop_coupon.stamps > shop_stamp.frames) {
              shop_coupon.stamps = shop_stamp.frames;
            }
          }
        },
        // スタンプカード追加
        addShopStamp: function () {
          let num = 1;
          if (this.shop_stamps.length > 0) {
            num =
              Number.parseInt(
                this.shop_stamps[this.shop_stamps.length - 1].rankup_threshold,
                10,
              ) + 1;
          }

          if (num > 50) {
            alertify.error('ランクアップの設定は、最大50枚目までです');
            return false;
          }

          this.shop_stamps.push({
            id: null,
            format: 'stamp',
            frames: 10,
            columns_per_record: 5,
            rankup_threshold: num,
            expire_type: 'none',
            bg: '',
            stamp: this.default_stamp_image,
            shop_coupons: [],
            is_suspend: false,
          });
          alertify.success('スタンプカードを追加しました');
        },
        // スタンプカード削除
        deleteShopStamp: function (index) {
          alertify
            .confirm(
              '本当に削除しますか？このカードをお持ちの会員がいる場合は、そのカードとクーポンはすべて削除されて使えなくなりますのでご注意ください。',
              (e) => {
                if (e) {
                  if (this.preview_stamp_index === index) {
                    this.preview_stamp_index = 0;
                  }
                  this.shop_stamps.splice(index, 1);
                } else {
                  return false;
                }
              },
            )
            .set('labels', { ok: '削除する', cancel: 'キャンセル' });
        },
        sortShopStamp: function () {
          // クーポンのスタンプ数順にソート
          this.shop_stamps.sort((a, b) =>
            Number.parseInt(a.rankup_threshold, 10) <
            Number.parseInt(b.rankup_threshold, 10)
              ? -1
              : 1,
          );
        },
        showShopStampAdvanced: () => {
          $('.advanced_options_stamp').slideDown();
          $('.advanced_options_stamp_btn').hide();
        },
        showShopCouponAdvanced: () => {
          $('.advanced_options_coupon').slideDown();
          $('.advanced_options_coupon_btn').hide();
        },
        showShopStampPreview: function (index) {
          this.preview_stamp_index = index;
        },
        // クーポン設定UI
        openShopCouponModal: (index) => {
          $(`.stamp-${index}-coupon`).modal();
          const height = `${window.innerHeight - 129 - window.innerHeight * 0.1 - 90}px`;
          $('.modal-body').css({ 'max-height': height, height: height });
        },
        addShopCoupon: function (parent_index) {
          const shop_stamp = this.shop_stamps[parent_index];

          const num = shop_stamp.frames;

          shop_stamp.shop_coupons.push({
            id: null,
            stamps: num,
            title: null,
            description: null,
            marked: true,
            picture_url_large: this.default_coupon_image,
            expire_type: 'stamp',
            confirm_code: '0',
            restricted_once: '',
            is_suspend: false,
            code_type: '',
          });
          alertify.success('クーポンを追加しました');

          this.sortShopCoupon(parent_index);

          $('.modal-body').animate(
            { scrollTop: $('.modal-body')[0].scrollHeight },
            'fast',
          );
        },
        sortShopCoupon: function (parent_index) {
          const shop_stamp = this.shop_stamps[parent_index];

          // 特典のスタンプ数順にソート
          shop_stamp.shop_coupons.sort((a, b) =>
            Number.parseInt(a.stamps, 10) < Number.parseInt(b.stamps, 10)
              ? -1
              : 1,
          );
        },
        changeShopCardIcon: function (e) {
          const shop_card = this.shop_card;

          const files = e.target.files || e.dataTransfer.files;
          if (!files.length) return;

          const reader = new FileReader();
          reader.onload = (e) => {
            shop_card.icon_url = e.target.result;
          };
          reader.readAsDataURL(files[0]);
        },
        changeShopStampBg: function (e, index) {
          const shop_stamp = this.shop_stamps[index];

          const files = e.target.files || e.dataTransfer.files;
          if (!files.length) return;

          const reader = new FileReader();
          reader.onload = (e) => {
            shop_stamp.bg = e.target.result;
          };
          reader.readAsDataURL(files[0]);
        },
        changeShopStampBgIndexUrl: function (e, index) {
          const shop_stamp = this.shop_stamps[index];

          const files = e.target.files || e.dataTransfer.files;
          if (!files.length) return;

          const reader = new FileReader();
          reader.onload = (e) => {
            shop_stamp.bg_index_url = e.target.result;
          };
          reader.readAsDataURL(files[0]);
        },
        changeShopStampStamp: function (e, index) {
          const shop_stamp = this.shop_stamps[index];

          const files = e.target.files || e.dataTransfer.files;
          if (!files.length) return;

          const reader = new FileReader();
          reader.onload = (e) => {
            shop_stamp.stamp = e.target.result;
          };
          reader.readAsDataURL(files[0]);
        },
        changeShopCouponPicture: function (e, parent_index, index) {
          const shop_stamp = this.shop_stamps[parent_index];
          const shop_coupon = shop_stamp.shop_coupons[index];

          const files = e.target.files || e.dataTransfer.files;
          if (!files.length) return;

          const reader = new FileReader();
          reader.onload = (e) => {
            shop_coupon.picture_url_large = e.target.result;
          };
          reader.readAsDataURL(files[0]);
        },
        deleteShopCoupon: function (parent_index, index) {
          const shop_stamp = this.shop_stamps[parent_index];

          alertify
            .confirm(
              '本当に削除しますか？このクーポンをお持ちの会員がいる場合は、そのクーポンはすべて削除されて使えなくなりますのでご注意ください。',
              (e) => {
                if (e) {
                  shop_stamp.shop_coupons.splice(index, 1);
                } else {
                  return false;
                }
              },
            )
            .set('labels', { ok: '削除する', cancel: 'キャンセル' });
        },
        // サブミット
        addEvent: function (e) {
          e.preventDefault();
          if (this.isValid) {
            $('#shop_card_bulk_submit')
              .prop('disabled', true)
              .html('読み込み中...');
            $('.shop_card_bulk_form').submit();
          }
        },
      },
      computed: {
        // プレビュー用にbrタグのみ許可したカード名
        sanitizedShopCardName() {
          return DOMPurify.sanitize(this.shop_card.name, {
            ALLOWED_TAGS: ['br'],
            ALLOWED_ATTR: [],
          });
        },
        // 人力バリデ
        isValid: function () {
          const errors = [];
          // shop_card validation
          if (!this.shop_card.name) {
            errors.push('カード名を入力してください');
          }
          // shop_stamp validation
          if (this.shop_stamps.length === 0) {
            errors.push('1枚以上の台紙を設定してください');
          }
          for (let i = 0; i < this.shop_stamps.length; i++) {
            const shop_stamp = this.shop_stamps[i];
            if (!shop_stamp.frames && shop_stamp.format === 'stamp') {
              errors.push('スタンプの枠数を入力してください');
            }
            // shop_coupon validation
            for (let j = 0; j < shop_stamp.shop_coupons.length; j++) {
              const shop_coupon = shop_stamp.shop_coupons[j];
              if (!shop_coupon.title) {
                errors.push('クーポンの内容を入力してください');
              }
              if (!shop_coupon.description) {
                errors.push('クーポンの概要を入力してください');
              }
              if (
                shop_coupon.stamps === null ||
                shop_coupon.stamps === undefined ||
                shop_coupon.stamps === ''
              ) {
                errors.push('クーポンのスタンプ数を選択してください');
              }
            }
          }
          // validate rankup 1st
          let flg_exist_first = false;
          for (const shop_stamp of this.shop_stamps) {
            if (Number.parseInt(shop_stamp.rankup_threshold, 10) === 1) {
              flg_exist_first = true;
            }
          }
          if (!flg_exist_first) {
            errors.push('1枚目からはじまるランクの台紙を設定してください');
          }
          // まとめてエラー出力
          if (errors.length > 0) {
            for (const elm of new Set(errors)) {
              alertify.error(elm);
            }
            return false;
          }
          return true;
        },
        // ポイントカードを含む場合
        includePointCard: function () {
          return this.shop_stamps[0].format === 'point';
        },
      },
    });

    // EnterでSubmitしない
    $(document).on(
      'keypress',
      'input:not(.allow_submit)',
      (e) => e.which !== 13,
    );

    $('#shop_card_form_tab_nav a').click(function (e) {
      e.preventDefault();
      $(this).tab('show');
    });
  }
}
